import ApiService, { HTTPMethod } from './api.core'
import { Transformer } from '../models/Transformer'

class PolicyManagementImpersonationApi {
  async modifyExistingHull(insuranceId, drones, equipment) {
    let res = await ApiService.fetch(
      `insurances/${insuranceId}`,
      HTTPMethod.PUT,
      {
        insured_drone_list: drones,
        insured_equipment_list: equipment,
      }
    )
    res.parsedData = Transformer.parseActiveInsuranceModel(res.data)
    return res
  }

  async generateAdditionalEndorsement(
    insuranceId,
    additionalInsuredId,
    endorsementText
  ) {
    return await ApiService.fetch(
      `insurances/${insuranceId}/extensions/additional_insured`,
      HTTPMethod.POST,
      {
        additional_insured_id: additionalInsuredId,
        additional_description: endorsementText,
      }
    )
  }
}

export default new PolicyManagementImpersonationApi()
